import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { PaymentService } from 'src/app/click-it/more/payments/service/payment.service';

@Component({
  selector: 'app-transaction-processing',
  templateUrl: './transaction-processing.component.html',
  styleUrls: [
    './transaction-processing.component.scss',
    './transaction-processing.component.rtl.scss',
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TransactionProcessingComponent implements OnInit {
  payment: any;
  locale: any;
  paymentObjet: any;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly store: Store,
    private readonly router: Router,
    private readonly paymentService: PaymentService
  ) {
    this.store
      .select((state) => state)
      .subscribe((data: any) => {
        this.locale = data.authReducer.userDetails?.country?.locale;
      });
  }

  ngOnInit(): void {
    console.log("checdfghjk");

    this.route.queryParams.subscribe((params) => {
      console.log(params, "params");
      if (this.locale === 'ar-EG') {
        this.paymentStatus(
          params['status'],
          params['paymentId'],
          params['redirectPage']
        );
      } else if (params['status'] == '=failed') {
        this.router.navigate(['create-orders', 'cement']);
      } else if (params['status'] == 'cancelled' && this.locale !== 'en-PH') {
        console.log("check", params['status']);
        let event = new CustomEvent('myCustomEvent', {
          detail: params['status'],
        });
        window.parent.document.dispatchEvent(event);
      } else if (this.locale === 'en-PH') {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            status: null
          },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
        this.paymentForPH(params);
      } else if (params['status'] == 'successful') {
        this.payment = {
          tx_ref: params['tx_ref'],
          id: params['transaction_id'],
          status: params['status'],
        };
        let data = this.payment;
        let event = new CustomEvent('myCustomEvent', { detail: data });
        this.router.navigate(['create-orders', 'cement'], {
          queryParams: data,
        });
        window.parent.document.dispatchEvent(event);
      } else {
        console.log("checkinhg");

        this.payment = {
          tx_ref: params['tx_ref'],
          id: params['transaction_id'],
          status: params['status'],
        };
        let data = this.payment;
        let event = new CustomEvent('myCustomEvent', { detail: data });
        window.parent.document.dispatchEvent(event);
      }
    });
  }

  // paymentForPH(params) {
  //   console.log(params, 'Params')
  //   let data = {
  //     request_id: localStorage.getItem('payment_id'),
  //   };
  //   this.paymentService.paymentStatusPaymongoPaynamics(data).subscribe({
  //     next: (result) => {
  //       if (
  //         (result.status && result.payment_status == 'success') ||
  //         result.payment_status == 'failed'
  //       ) {
  //         data['status'] = result.payment_status;
  //         this.router.navigate(['create-orders', 'cement'], {
  //           queryParams: data,
  //         });
  //       }
  //     },
  //   });
    // if (params['status'] == 'successful') {
    //   let data = {
    //     request_id: localStorage.getItem('payment_id'),
    //   };
    //   this.paymentService.paymentStatusPaymongoPaynamics(data).subscribe({
    //     next: (result) => {
    //       if (
    //         (result.status && result.payment_status == 'success') ||
    //         result.payment_status == 'failed'
    //       ) {
    //         data['status'] = result.payment_status;
    //         this.router.navigate(['create-orders', 'cement'], {
    //           queryParams: data,
    //         });
    //       }
    //     },
    //   });
    // } else if (params['status'] == '=failed') {
    //   this.payment = {
    //     tx_ref: params['tx_ref'],
    //     id: params['transaction_id'],
    //     status: params['status'],
    //   };
    //   let data = this.payment;
    //   data['status'] = params['status'];
    //   let event = new CustomEvent('myCustomEvent', { detail: data });
    //   window.parent.document.dispatchEvent(event);
    // } else {
    //   let data = {
    //     request_id: localStorage.getItem('payment_id'),
    //   };
    //   this.paymentService.paymentStatusPaymongoPaynamics(data).subscribe({
    //     next: (result) => {
    //       if (result.status && result.payment_status == 'success') {
    //         data['status'] = result.payment_status;
    //         let event = new CustomEvent('myCustomEvent', { detail: data });
    //         window.parent.document.dispatchEvent(event);
    //       }
    //     },
    //     error: (err) => {
    //       console.log(err);
    //     },
    //   });
    // }
  // }
paymentForPH(params) {
  console.log(params, 'Params');

  const data = {
    request_id: localStorage.getItem('payment_id'),
  };

  this.paymentService.paymentStatusPaymongoPaynamics(data).subscribe({
    next: (result) => {
      if (
        (result.status && result.payment_status === 'success') ||
        result.payment_status === 'failed'
      ) {
        data['status'] = result.payment_status;

        this.router.navigate(['create-orders', 'cement'], {
          queryParams: data,
        });
      }
    },
    error: (err) => {
      console.log(err);
    }
  });
}
  paymentStatus(status, paymentId, redirectPage) {
    if (status === 'canceled') {
      this.router.navigate(['more', 'payments', 'add-payment'], {
        queryParams: {
          status: 'canceled',
        },
      });
    } else if (status === 'failed') {
      this.router.navigate(['more', 'payments', 'add-payment'], {
        queryParams: {
          status: 'failed',
        },
      });
    } else {
      let obj = {
        payment_id: paymentId ?? localStorage.getItem('payment_id')
      };

      this.paymentService.paymentStatus(obj).subscribe({
        next: (result) => {
          if (result?.message === 'successful') {
            localStorage.removeItem('payment_id');
            this.router.navigate(['more', 'payments']);
          } else {
            this.router.navigate(['more', 'payments', 'add-payment'], {
              queryParams: {
                status: 'canceled',
              },
            });
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
    }
  }
}
